import React from "react";
import { Outlet } from "react-router-dom";

const AuthContainer = () => {
  return (
    <div className="main min-h-screen w-full">
      <Outlet />
    </div>
  );
};

export default AuthContainer;
